// 将时间戳转换成日期格式
export function timestampToTime (timestamp) {
  const time = new Date(timestamp)
  const y = time.getFullYear()
  const m = time.getMonth() + 1
  const d = time.getDate()
  const h = time.getHours()
  const mm = time.getMinutes()
  const s = time.getSeconds()
  return y + '-' + add0(m) + '-' + add0(d) + ' ' + add0(h) + ':' + add0(mm) + ':' + add0(s)
}

export function timestampToTime2 (timestamp) {
  const time = new Date(timestamp)
  const m = time.getMonth() + 1
  const d = time.getDate()
  return add0(m) + '-' + add0(d)
}

// 将时间转换成日期格式
export function timestampToTime3 (time) {
  const y = time.getFullYear()
  const m = time.getMonth() + 1
  const d = time.getDate()
  const h = time.getHours()
  const mm = time.getMinutes()
  const s = time.getSeconds()
  return y + '-' + add0(m) + '-' + add0(d) + ' ' + add0(h) + ':' + add0(mm) + ':' + add0(s)
}

// 将时间转换成日期格式
export function timestampToTime4 (time, type) {
  const y = time.getFullYear()
  const m = time.getMonth() + 1
  const d = time.getDate()
  const h = time.getHours()
  const mm = time.getMinutes()
  const s = time.getSeconds()
  if (type === 'seconds') {
    return y + '' + add0(m) + '' + add0(d) + '' + add0(h) + '' + add0(mm) + '' + add0(s)
  } else if (type === 'minutes') {
    return y + '' + add0(m) + '' + add0(d) + '' + add0(h) + '' + add0(mm)
  } else if (type === 'hour') {
    return y + '' + add0(m) + '' + add0(d) + '' + add0(h)
  } else if (type === 'day') {
    return y + '' + add0(m) + '' + add0(d)
  } else if (type === 'month') {
    return y + '' + add0(m)
  }
}

// 将时间戳转换成日期格式
export function timestampToTime5 (timestamp) {
  const time = new Date(timestamp)
  const y = time.getFullYear()
  const m = time.getMonth() + 1
  const d = time.getDate()
  return y + '/' + add0(m) + '/' + add0(d)
}

export function timestampToTime6 (time, type) {
  const y = time.getFullYear()
  const m = time.getMonth() + 1
  const d = time.getDate()
  const h = time.getHours()
  const mm = time.getMinutes()
  const s = time.getSeconds()
  if (type === 'seconds') {
    return y + '-' + add0(m) + '-' + add0(d) + ' ' + add0(h) + ':' + add0(mm) + ':' + add0(s)
  } else if (type === 'minutes') {
    return y + '-' + add0(m) + '-' + add0(d) + ' ' + add0(h) + ':' + add0(mm)
  } else if (type === 'hour') {
    return y + '-' + add0(m) + '-' + add0(d) + ' ' + add0(h)
  } else if (type === 'day') {
    return y + '-' + add0(m) + '-' + add0(d)
  } else if (type === 'month') {
    return y + '-' + add0(m)
  }
}

export function timeToDate (time) {
  const y = time.getFullYear()
  const m = time.getMonth() + 1
  const d = time.getDate()
  return y + '-' + add0(m) + '-' + add0(d)
}

export function timeToMonth (time) {
  const y = time.getFullYear()
  const m = time.getMonth() + 1
  return y + '-' + add0(m)
}

export function timeToDate2 (time) {
  const y = time.getFullYear()
  const m = time.getMonth() + 1
  const d = time.getDate()
  const h = time.getHours()
  const mm = time.getMinutes()
  return y + '-' + add0(m) + '-' + add0(d) + ' ' + add0(h) + ':' + add0(mm)
}

export function timeToDate3 (time) {
  const y = time.getFullYear()
  const m = time.getMonth() + 1
  const d = time.getDate()
  return y + '' + add0(m) + '' + add0(d)
}

export function timeTohms (time) {
  const h = time.getHours()
  const mm = time.getMinutes()
  const s = time.getSeconds()
  return add0(h) + ':' + add0(mm) + ':' + add0(s)
}

function add0 (m) {
  return m < 10 ? '0' + m : m
}

// 计算时间差
export function timeFn (d1) {
  // 如果时间格式是正确的，那下面这一步转化时间格式就可以不用了
  const dateBegin = new Date(d1.replace(/-/g, '/'))// 将-转化为/，使用new Date
  const dateEnd = new Date()// 获取当前时间
  const dateDiff = dateEnd.getTime() - dateBegin.getTime()// 时间差的毫秒数
  const minutes = Math.floor(dateDiff / (60 * 1000))// 计算相差分钟数
  return minutes
}

// 根据时间段循环获取每一天
export function dealDate (start, end) {
  let dateList = []
  var startTime = new Date(start)
  var endTime = new Date(end)
  while ((endTime.getTime() - startTime.getTime()) >= 0) {
    // var year = startTime.getFullYear()
    var month = startTime.getMonth() + 1 < 10 ? '0' + (startTime.getMonth() + 1) : startTime.getMonth() + 1
    var day = startTime.getDate().toString().length === 1 ? '0' + startTime.getDate() : startTime.getDate()
    // dateList.push(year + "/" + month + "/" + day)
    dateList.push(month + '-' + day)
    startTime.setDate(startTime.getDate() + 1)
  }
  return dateList
}



// WEBPACK FOOTER //
// ./src/utils/timestamp.js